import { cx } from '@twind/core';
import React, { useState } from 'react';
import { Popover as TinyPopover, ArrowContainer, PositionTransform, PopoverPosition } from 'react-tiny-popover';

import CloseIcon from './icons/CloseIcon';

interface PopoverProps {
  button: JSX.Element;
  children: JSX.Element;
  className?: string;
  transform?: PositionTransform;
  positions?: PopoverPosition | PopoverPosition[];
}

const getElement = (id: string) => {
  return document.getElementById('webchatv4')?.shadowRoot?.getElementById(id) as HTMLElement;
};

export default function Popover({ button, children, className, transform, positions }: PopoverProps) {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopover = () => setIsOpen(!isOpen);

  return (
    <TinyPopover
      transform={transform}
      transformMode="relative"
      boundaryElement={getElement('ostro-widget-container')}
      parentElement={getElement('root')}
      containerClassName="z-30"
      isOpen={isOpen}
      positions={positions}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="currentColor"
          arrowSize={10}
          arrowStyle={{ opacity: 0.7 }}
          className="popover-arrow-container"
          arrowClassName="popover-arrow text-option"
        >
          <div className="relative">
            <button
              className="absolute top-3 right-3"
              onClick={() => setIsOpen(false)}
            >
              <CloseIcon className="w-3 h-3 fill-black text-black" />
            </button>
            {React.cloneElement(children, {
              className: cx('~(bg-option p-6 pt-8 rounded-xl w-[230px])', children.props.className),
            })}
          </div>
        </ArrowContainer>
      )}
    >
      {React.cloneElement(button, {
        onClick: togglePopover,
        className,
      })}
    </TinyPopover>
  );
}
